// Typewriter effects.
// - .typer[data-words="a|b|c"]: types each word, holds it, deletes it, moves on.
// - .typed-block: types its text once, the first time its slide becomes active.
const TYPE_MS = 55;
const DELETE_MS = 28;
const HOLD_MS = 1600;
const BLOCK_MS = 16;

export default function initTyper() {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll(".typer[data-words]").forEach((el) => {
    const words = el.dataset.words.split("|");
    if (reduceMotion) {
      el.textContent = words[0];
      return;
    }
    let w = 0;
    let i = 0;
    let deleting = false;
    const tick = () => {
      const word = words[w];
      i += deleting ? -1 : 1;
      el.textContent = word.slice(0, i);
      let delay = deleting ? DELETE_MS : TYPE_MS;
      if (!deleting && i === word.length) {
        deleting = true;
        delay = HOLD_MS;
      } else if (deleting && i === 0) {
        deleting = false;
        w = (w + 1) % words.length;
        delay = 300;
      }
      setTimeout(tick, delay);
    };
    tick();
  });

  document.querySelectorAll(".typed-block").forEach((el) => {
    const text = el.textContent.trim();
    el.parentElement.setAttribute("aria-label", text);
    if (reduceMotion) return;
    el.textContent = "";
    const slide = el.closest(".slide");
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      let i = 0;
      const tick = () => {
        i += 1;
        el.textContent = text.slice(0, i);
        if (i < text.length) setTimeout(tick, BLOCK_MS);
      };
      setTimeout(tick, 500);
    };
    if (slide.classList.contains("is-active")) start();
    document.addEventListener("slidechange", () => {
      if (slide.classList.contains("is-active")) start();
    });
  });
}
